import { render, staticRenderFns } from "./NewCommunity.vue?vue&type=template&id=35d349de&scoped=true&"
import script from "./NewCommunity.vue?vue&type=script&lang=js&"
export * from "./NewCommunity.vue?vue&type=script&lang=js&"
import style0 from "./NewCommunity.vue?vue&type=style&index=0&id=35d349de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d349de",
  null
  
)

export default component.exports